import { NgClass, NgFor } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-pagination',
  standalone: true,
  imports: [NgClass, NgFor],
  templateUrl: './pagination.component.html',
  styleUrl: './pagination.component.css'
})
export class PaginationComponent {
  @Input() page = 1;                // The current page number
  @Input() totalPage = 0;           // The total number of pages
  @Output() newPage = new EventEmitter<number>();  // Event emitter to notify the parent component about the page change
  maxPagesToShow = 5;

  ngOnInit(): void {
    // console.log('Child Component-', this.totalPage);
  }

  getPagesToDisplay(): number[] {
    const pages = [];
    let startPage = Math.max(1, this.page - Math.floor(this.maxPagesToShow / 2));
    let endPage = startPage + this.maxPagesToShow - 1;

    // adjust if endPage exceeds total pages
    if (endPage > this.totalPage) {
      endPage = this.totalPage;
      startPage = Math.max(1, endPage - this.maxPagesToShow + 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }
    return pages;
  }

  pageChange(item: number) {
    if (item >= 1 && item <= this.totalPage) {
     this.page = item;
     this.newPage.emit(item);
    }
  }

  counter(i: number) {
    return new Array(i);
  }

  trackByFn(index: number, item: any): any {
    return index; // or return a unique identifier for the item
  }
}
